import { Text } from '@chakra-ui/react';
import React, { Component } from 'react';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI
    console.error(error);
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(error, info);
    // You can log the error to a centralized service or perform other actions
  }

  render() {
    if (this.state.hasError) {
      // Render a custom fallback UI
      return <Text color="error.500">Something went wrong. Please try again later.</Text>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
